import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { ArrowLeft } from 'lucide-react';

export default function ProximamentePage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <Card data-testid="proximamente-card" className="max-w-md w-full p-8 text-center">
        <div className="mx-auto w-16 h-16 rounded-full bg-[hsl(var(--brand-teal-100))] flex items-center justify-center mb-6">
          <svg
            className="w-8 h-8 text-[hsl(var(--brand-teal))]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight mb-3">
          Próximamente
        </h1>
        <p className="text-sm sm:text-base text-muted-foreground mb-8">
          Estamos trabajando en esta funcionalidad. Pronto podrás acceder al panel de FluxiPay.
        </p>
        <Link to="/">
          <Button data-testid="back-home-button" variant="default" className="w-full">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Volver al inicio
          </Button>
        </Link>
      </Card>
    </div>
  );
}